import type { StandaloneEditTarget } from './campaign-editability';

/**
 * FE#259 — the ordered 3-dot menu keys for a STANDALONE campaign.
 *
 * The standalone branch of use-drip-actions built its menu inline and never
 * offered Duplicate — so a completed campaign's menu was only Rename + Delete
 * (Noam's "no duplicate option"). This pure function is the single, testable
 * source of the key set + order, so the menu contents (incl. the new Duplicate)
 * are verified independently of the hook and its handlers.
 *
 * Order: rename → the editability-tiered edit item (if any) → duplicate →
 * stop-recurring (recurring only) → delete.
 */

export type StandaloneActionKey =
  | 'rename'
  | 'edit-schedule'
  | 'edit-content'
  | 'duplicate'
  | 'stop-recurring'
  | 'delete';

export const standaloneCampaignActionKeys = (
  editTarget: StandaloneEditTarget,
  opts: { isRecurring: boolean },
): StandaloneActionKey[] => {
  const keys: StandaloneActionKey[] = ['rename'];
  if (editTarget === 'schedule-editor') keys.push('edit-schedule');
  else if (editTarget === 'campaign-editor') keys.push('edit-content');
  keys.push('duplicate');
  if (opts.isRecurring) keys.push('stop-recurring');
  keys.push('delete');
  return keys;
};
